import { SVGProps } from "react"
import { Flex } from "../ui/components/base/Flex"
import { Body } from "../ui/components/typography/Body"
import { useLocalize } from "../../../../packages/localization/client-side/useLocalize"
import { Button } from "../ui/components/buttons/Button"

export function ErrorPage() {
    const localize = useLocalize()
    return (
        <Flex direction="column" alignItems="center">
            <Flex
                style={{ width: "100%", maxWidth: 640, textAlign: "center" }}
                gap={32}
                direction="column"
                alignItems="center"
            >
                <div style={{ width: "100%", maxWidth: 480, padding: "40px 32px 0 32px" }}>
                    <Error404Svg width="100%" height="auto" />
                </div>
                <Body size="lg">
                    {localize({
                        no: "Kunne ikke finne siden du lette etter.",
                        en: "Could not find the page you were looking for.",
                    })}
                </Body>
                <div>
                    <Button variant="primary" as="a" href="/">
                        {localize({ no: "Gå til forsiden", en: "Go to home page" })}
                    </Button>
                </div>
            </Flex>
        </Flex>
    )
}

const Error404Svg = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1841 1129"
        width={1841}
        height={1129}
        fill="none"
        {...props}
    >
        <path
            fill="#F6F6F6"
            d="M927.87 1128.2c311.44 0 563.92-252.476 563.92-563.92C1491.79 252.836 1239.31.36 927.87.36c-311.444 0-563.92 252.476-563.92 563.92 0 311.444 252.476 563.92 563.92 563.92Z"
        />
        <path
            fill="url(#a)"
            d="M1538.64 1023.47c166.99 0 302.37-18.44 302.37-41.18 0-22.743-135.38-41.18-302.37-41.18s-302.37 18.437-302.37 41.18c0 22.74 135.38 41.18 302.37 41.18Z"
        />
        <path
            fill="url(#b)"
            d="M1509.8 988.78c118.22 0 214.05-4.589 214.05-10.25s-95.83-10.25-214.05-10.25c-118.22 0-214.05 4.589-214.05 10.25s95.83 10.25 214.05 10.25Z"
        />
        <path
            fill="url(#c)"
            d="M1509.8 988.78c118.22 0 214.05-4.589 214.05-10.25s-95.83-10.25-214.05-10.25c-118.22 0-214.05 4.589-214.05 10.25s95.83 10.25 214.05 10.25Z"
        />
        <path
            fill="url(#d)"
            d="M932.24 1023.47c237.57 0 430.16-18.44 430.16-41.18 0-22.743-192.59-41.18-430.16-41.18-237.571 0-430.16 18.437-430.16 41.18 0 22.74 192.589 41.18 430.16 41.18Z"
        />
        <path
            fill="url(#e)"
            d="M482.05 1023.47c166.994 0 302.37-18.44 302.37-41.18 0-22.743-135.376-41.18-302.37-41.18s-302.37 18.437-302.37 41.18c0 22.74 135.376 41.18 302.37 41.18Z"
        />
        <path fill="url(#f)" d="M897.53 1023.02h-80.19l39.83 15.81 40.36-15.81Z" />
        <path fill="url(#g)" d="M762.85 992.79h-41.79l39.82 15.81 1.97-15.81Z" />
        <path fill="url(#h)" d="M1134.71 1002.69h50.82l13.55-13.91h-53.61l-10.76 13.91Z" />
        <path fill="url(#i)" d="M1526.24 1023.57h50.82l-36.14-6.95-58.46-6.96 43.78 13.91Z" />
        <path fill="url(#j)" d="M1204.08 941.7h50.82l-12.52-3.39-13.93-3.56-24.37 6.95Z" />
        <path fill="url(#k)" d="M1386.85 941.7h50.83l-12.53-3.39-13.92-3.56-24.38 6.95Z" />
        <path fill="url(#l)" d="M1628.41 948.66h50.82l-12.52-3.39-30.68-3.57-7.62 6.96Z" />
        <path fill="url(#m)" d="M1770.33 965.74h38.22l-17.28-6.96-26.35 3.48 5.41 3.48Z" />
        <path fill="url(#n)" d="M1042.47 1016.62h16.19l7.91 6.4-21.08 2.63-3.02-9.03Z" />
        <path fill="url(#o)" d="M897.53 1038.83h20.62l-4.81 7.15-19.57-3.57 3.76-3.58Z" />
        <path fill="url(#p)" d="M658.85 930.41h-56.09l11.29 11.29h22.21l22.59-11.29Z" />
        <path fill="url(#q)" d="m232.83 930.41-38.35 5.64-6.45 5.65h22.21l22.59-11.29Z" />
        <path fill="url(#r)" d="M110 1002.41H53.91l-4.42 11.29H71.7l38.3-11.29Z" />
        <path fill="url(#s)" d="M19.39 933.27.78 941.11l15.01.59H38l-18.61-8.43Z" />
        <path fill="url(#t)" d="m352.72 950.45-20.62 1.93 15.32 5.65h22.21l-16.91-7.58Z" />
        <path fill="url(#u)" d="M655.46 911.58h19.96v-4.14l-16.57-4.14-3.39 8.28Z" />
        <path fill="url(#v)" d="M992.53 1004.67h-8.32l4.16 4.23 20.97-2.12-16.81-2.11Z" />
        <path fill="url(#w)" d="M1159.27 959.49h9.89l-2.26-2.92-20.62 1.46 12.99 1.46Z" />
        <path fill="url(#x)" d="M1305.81 938.31h24.29l-4.87 7.91-19.42-3.95v-3.96Z" />
        <path fill="url(#y)" d="M557.58 995.73h24.28l7.34-6.95-31.62 6.95Z" />
        <path
            fill="url(#z)"
            d="M1201.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
        />
        <path
            fill="#9B64E1"
            d="M1201.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
        />
        <path
            fill="url(#A)"
            d="M1232.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
        />
        <path fill="#9B64E1" d="M1232.34 629.45h-31v131.71h31V629.45Z" />
        <path
            fill="url(#B)"
            d="M875.69 988.78c118.216 0 214.05-4.589 214.05-10.25s-95.834-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
        />
        <path
            fill="url(#C)"
            d="M498.98 988.78c118.217 0 214.05-4.589 214.05-10.25s-95.833-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
        />
        <path
            fill="url(#D)"
            d="M498.98 988.78c118.217 0 214.05-4.589 214.05-10.25s-95.833-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
        />
        <path
            fill="#CCADF2"
            d="M176.73 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H437.63V761.16h-260.9Zm260.9-424.27L290.72 647.18h146.91V336.89Z"
        />
        <path
            fill="#9B64E1"
            d="M176.73 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H437.63V761.16h-260.9Zm260.9-424.27L290.72 647.18h146.91V336.89Z"
        />
        <path
            fill="url(#E)"
            d="M144.66 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H405.56V761.16h-260.9Zm260.9-424.27L258.65 647.18h146.91V336.89Z"
        />
        <path
            fill="#9964DF"
            d="m908.34 49.33-292.855 98.386c-36.119 12.134-55.562 51.25-43.428 87.369l233.727 695.708c12.134 36.119 51.25 55.562 87.369 43.428l292.857-98.386c36.12-12.134 55.56-51.251 43.42-87.369L995.709 92.757C983.574 56.64 944.458 37.196 908.34 49.33Z"
        />
        <path
            fill="#130722"
            d="M1207.68 808.66c8.95 26.65-5.44 55.62-32.1 64.57l-292.86 98.38c-26.65 8.95-55.62-5.45-64.57-32.1L584.43 243.79c-8.95-26.65 5.44-55.62 32.1-64.57l292.86-98.38c26.65-8.95 55.62 5.44 64.57 32.1l233.72 695.72Z"
        />
        <path
            fill="#9B64E1"
            d="M1186.94 802.27c8.95 26.65-5.44 55.62-32.1 64.57l-292.86 98.38c-26.65 8.95-55.62-5.45-64.57-32.1L563.69 237.4c-8.95-26.65 5.44-55.62 32.1-64.57l292.86-98.38c26.65-8.95 55.62 5.44 64.57 32.1l233.72 695.72Z"
        />
        <path
            fill="url(#F)"
            d="M893.658 53.764 600.803 152.15c-36.118 12.134-55.561 51.25-43.427 87.369l233.726 695.708c12.134 36.119 51.251 55.562 87.369 43.428l292.859-98.386c36.11-12.134 55.56-51.251 43.42-87.369L981.027 97.191c-12.134-36.118-51.251-55.561-87.369-43.427Z"
        />
        <path
            fill="#B489EA"
            d="M893.658 53.764 600.803 152.15c-36.118 12.134-55.561 51.25-43.427 87.369l233.726 695.708c12.134 36.119 51.251 55.562 87.369 43.428l292.859-98.386c36.11-12.134 55.56-51.251 43.42-87.369L981.027 97.191c-12.134-36.118-51.251-55.561-87.369-43.427Z"
        />
        <path
            fill="url(#G)"
            d="m1051.24 393.19 30.45 3.67-1.41-4.2-67.74-8.16 1.86-26.36 30.07-55.51-3.52-1.91-29.1 53.71-.48-3.21-28.48 4.27-7.54-22.45 71.08-41.14-1.3-3.87-73.35 42.46-7.17-2.23 32.14-24.83 30.34-69.11-1.89-5.64-31.7 72.2-33.56 25.93-10.65-3.31 18.24-34.52 11.49 13.42-9.62-16.97 45.76-86.61-1.76-5.24-68.32 129.31-7.67 1.32 29.96-110.75.03-.1 17.61-104.27-.65-1.93-1.01-3.01-41.86 92.35-12.06-.05-2.19 94.61-10.47.24-26.15-147.47 26.2-93.66c-1.39-.02-2.78 0-4.17.06l-26 92.96-.12.44 32.65 184.12-7.44 3.09-67.14-130.96-.11-.22-87.72-99.93-4.11 1.38 88.49 100.82 9.66 18.85-19.42 10.17-55.72-34.56-50.85-85.93-3.88 1.3 94.64 159.92 12.87 5.89-17.6 17.93-68.48-37.84-133.85-108.14-4.5 1.51 19.56 15.8-.76.31L666.51 273l-26.64 67.64-51.01-7.3 1.43 4.24 49.75 7.12 58.89 80.23-73.01 18.7 1.28 3.8 179.7-46.03 54.21-9.89-.24 16.85-65.11 25.35-151.03 65.9 1.28 3.81 87.39-38.13-.38.3 14.71 18.23-89.41 56.26 1.31 3.9 90.62-57.03 28.03 34.75-29.71 29.79-24.42-.09h-.79l-46.61 43.57 1.4 4.17 46.78-43.74 75.7.27-11.94 53.49 7.51 22.36-54.57 156.56 2.08 6.19 56.72-162.73-7.59-22.6 12.78-57.25-51.42-.19 68.21-68.4 25.19 111.4-22.56 69.89 21.35 19.14-37.35 142.96-39.81 43.78 1.46 4.34 40.62-44.68 55.22 27.59-59.2 104.17c.97.98 1.97 1.92 2.99 2.84l60.73-106.86.17-.3 23.03-130.93 41.72 37.4.76-.85 1.14 31.73-28.53 173.51 4.29-1.44 28.21-171.61.03-.2-2.63-72.85 59.56-68.01 21.33-4.26 10.21 46.9-27.94 55.67-1.17 184.92 4.01-1.35 1.16-182.61 24.46-48.74 5.61 103.64.04.76 86.44 87.41 4.22-1.42-86.75-87.72-3.97-73.35 132.92 26.81 43.86 79.88c.67-1.65 1.27-3.32 1.81-5.01l-77.4-140.97-.23-.42L1095 665.6l-91.11-158.11 41.21-20 46.21 54.43-21.93 20.01 24.36-17.15 61.33 70.67-2.56-7.62-100.09-117.89 13.03-24.37-15.55 21.4-36.81-43.36 23.06-18.83 15.03-31.62.06.03Zm-67.56-33.76 27.72-4.16-.73 1.35-.21.38-1.9 27.02-23.06-2.78-1.83-21.81h.01Zm-25.86 141.68-17.66-83.8.6.08 5.99-1.13 36.33 63.04 13.88 63.76-12.97 3.25-12.38-36.86-13.79-8.35v.01Zm-62.65-119.82-2.78-10.32 24.09-4.94-.82 8.46-20.03 7.98-.22-1.23-.23.04-.01.01Zm-28.56-50.38 27.69 15.3-5.96 20.82-27.04-1.65 5.31-34.46v-.01Zm-9.32 34.22-62.7-3.83 33.03-17.44 2.68-33.01 32.58 18-5.59 36.28Zm66.84-8.4 13.79-4.63 10.36 19.46-24.15-14.83Zm23.84 19.33-17.55 8.35 6.5-15.13 11.05 6.78Zm-14.49-8.9-7.22 16.8-6.67-8.65 1.39-14.25.1.12.11-1.56 12.29 7.54Zm-16.6-5.3-24.33 4.98 3.63-12.69 21.09 3.69-.39 4.02Zm-19.59-11.57 1.19-4.17 4.44-6.13 11.37 13.27-17-2.98v.01Zm-1.21-7.67-25.03-13.83-1.51-19.29 30.24 28-3.71 5.12h.01Zm20.78 35.7 7.61 9.88-15.48 18.94-5.07-5.75-6.88-15.17 19.81-7.9h.01Zm10.15 13.09 17.14 21.28-3.49.66-28.35-3.95 14.71-17.99h-.01Zm8.94 25.32 18.31 86.91 14.02 8.49 11.82 35.18-46.67 11.71-5.17-143.36 7.68 1.07h.01Zm14.76-1.6 22.53-12.32 24.21 28.52-23.57 24.01-23.17-40.21Zm-2.17-3.37-18.37-22.81 22.97-10.92 27.53 5.47-6.76 14.4-25.36 13.86h-.01Zm5.66-37.6-.31-.57 21.24-28.6 4.42 13.15 1.79 21.41-27.15-5.39h.01Zm19.39-33.8-21.77 29.31-10.18-19.12 30.44-14.71 1.52 4.52h-.01Zm-28.45-13.4 1.82.96.42-.8 20.42 6.34-29.67 14.34-4.48 1.51 2.71-20.84 8.78-1.51Zm-27.65-31.64 13.67-.32 2.19-94.51 10.73.04 33.07-72.95-13.65 84.96-30.42 112.45-10.02 1.73-5.57-31.39v-.01Zm5.82 35.4 8.93-1.54-2.81 21.54-7.78 2.61 1.66-22.62v.01Zm-4.11 1.39-1.4 19.1-11.7-13.65 13.1-5.45Zm-11.16.31-5.42 2.25-37.91-35.1 15.68-21.1 27.66 53.95h-.01Zm-89.64-63.81-38.31-64.74 51.15 31.72 21.41-11.22 25.7 50.13-16.6 22.34-17.96-16.63-25.39-11.61v.01Zm13.94 10.77 9.21 4.21 23.67 21.91 1.64 20.98-52.35-28.93 17.83-18.17Zm-161.48-6.37-42.09-101.97 111.25 89.88.14.11 86.3 47.69-2.65 32.62-36.9 19.48-10.9-.67-132.03-18.89 26.88-68.25Zm135.28 124.52h-.07l-102.94 26.38-57.52-78.37 129.9 18.59 112.74 6.9 2.96 10.98-85.07 15.52Zm59.01-6.7 27.34-4.99 3.96 8.73-31.52 12.27.23-16.01h-.01Zm32.95 7.39 1.07 2.36-56.51 56.66-22.49-28.68 77.93-30.34ZM781.16 518.89l-44.39-55.02 60.54-26.42 18.96-7.38 23.53 30.02-58.65 58.8h.01Zm44.64-39.09 75.34-75.54 5.81 6.59-15.83 49.04-25.65-14.08 24.47 17.76-39.86 123.51-24.26-107.28h-.02Zm54 28.17c11.08 13.16 22.46 27.23 24.28 30.49-.38 2.03-.33 6.71 0 18.2.18 6.19.46 13.98.84 23.23l-18.21-28.76-24.72 12.02 17.81-55.17v-.01Zm-11.94 345.78-54.61-27.29 16.91-64.7 45.54 47.47-7.83 44.52h-.01Zm8.69-49.4-45.21-47.13 18.46-70.63 41 36.76-14.25 81ZM829.69 663.2l30.6-94.79 24.95-12.13 20.01 31.61c.11 2.54.22 5.16.34 7.88 1.18 26.71 2.56 53.69 2.71 56.46l-12.61 70.15-66-59.17v-.01Zm106.95 95.88-37.45-33.57 13.13-73.03v-.23c-2.24-43.12-5.24-108.79-4.33-112.99-.05.24-.37.94-1.2 1.22l1.35-1.43c.36-1.29.6-2.14-13.79-19.78-5.53-6.77-11.15-13.47-13.1-15.78l29.15-90.32 13.84 1.93 12.4 343.99v-.01Zm58.92-107.19-56.45 64.46-3.35-92.86 28.39 16.56h27.44l3.97 11.83v.01Zm3.59-1.85-4.69-13.97h-29.23l-29.64-17.31-2.01-55.66 64.23-16.12 21.55 99.02-20.21 4.04Zm92.68 18 .23.4 42.37 28.64 32.49 59.17-130.62-26.35-1.78-32.93v-.16l-15.93-73.15 33.13-25.24 40.11 69.61v.01Zm-42.12-73.11-32.05 24.42-28-128.62 60.05 104.2Zm-32.96-140.87-16.32 14.96 18.69-12.16 23.36 27.52-40.54 19.68-26-45.11 24.09-24.55 16.7 19.67.02-.01Zm-6.19-13.47-33.73-39.73.14-.08 7.35-15.65 62.73 7.56-14.07 29.59-22.42 18.31Z"
        />
        <path
            fill="url(#H)"
            d="m797.021 117.589-81.011 27.216c-9.46 3.178-14.552 13.423-11.374 22.883 3.178 9.461 13.423 14.553 22.884 11.375l81.01-27.216c9.46-3.178 14.553-13.423 11.375-22.884-3.179-9.46-13.424-14.552-22.884-11.374Z"
        />
        <path
            fill="#9964DF"
            d="M803.94 139.99a5.65 5.65 0 1 0-.001-11.301 5.65 5.65 0 0 0 .001 11.301Z"
        />
        <path
            fill="#fff"
            d="m921.38 417.41 13.18-26.51 26.51 13.18 17.81-35.82-26.51-13.18 13.18-26.51-35.82-17.8-13.18 26.51-26.51-13.18-17.8 35.82 26.51 13.18-13.18 26.51 35.82 17.8h-.01Zm-162.83 54.7 13.18-26.51 26.51 13.18 17.8-35.82-26.51-13.18 13.18-26.51-35.82-17.8-13.18 26.51-26.51-13.18-17.8 35.82 26.51 13.18-13.18 26.51 35.82 17.8Zm159.83 140.33c-.14.05-.3.1-.45.15-75.92 25.7-109.61 87.75-118.12 106.15l36.3 16.8c6.82-14.75 33.82-64.47 94.65-85.06l.36-.12c61.07-20.52 112.76 2.88 127.16 10.55l18.8-35.31c-17.98-9.57-82.47-38.77-158.7-13.16Z"
        />
        <path
            fill="#F6F6F6"
            d="M1069.93 622.03c-1.88-.88-3.95-1.82-6.23-2.79l8.71 15.11 2.22-4.16-4.7-8.16ZM831.77 670.44l14.67 13.15-13.22 50.61 2.89 1.34c.52-1.13 1.18-2.48 1.94-3.99l11.75-44.95 11.71 10.5c.87-.99 1.76-1.98 2.67-2.98l-29.73-26.65c-.91.99-1.8 1.99-2.67 2.98l-.01-.01ZM1023.82 647.69l-5.23-24.02 18.17-13.84c-1.6-.44-3.24-.87-4.9-1.29l-14.2 10.82-3.14-14.43c-1.39-.23-2.81-.45-4.24-.65l9.08 41.73-1.37.27c1.99.45 3.94.92 5.83 1.41ZM908.3 652.23l-1.56 8.68c1.47-.79 2.96-1.56 4.48-2.31l1.1-6.12v-.23c-.6-11.28-1.23-24.11-1.84-36.97-1.32.51-2.63 1.03-3.92 1.56.87 18.37 1.64 33.37 1.74 35.39ZM937.41 324.23l2.3-8.49-3.65-1.82-2.99 11.05-10.02 1.73-.33-1.86-3.63 7.31.11-.04-1.4 19.1-11.7-13.65 5.99-2.49-4.75-2.36-4.72 1.96-10.06-9.31-2.52-1.25-1.49 2.99 11.24 10.4-3.71 5.12-11.96-6.61-1.78 3.59 11.96 6.61-5.96 20.82-2.08-.13 7.58 3.77 22.64-4.64-.82 8.46-20.03 7.98-.22-1.23-.23.04-.18-.65-2.6 5.22.09-.02 3.96 8.73-10.39 4.04-.49 1 3.94 1.96 8.6-3.35 1.07 2.36-3.86 3.87 3.78 1.88 2.05-2.06 4.83 5.48 7.83 3.89 8.85 1.23 1.88-3.78-12.21-1.7 14.71-17.99 4.51 5.6 1.96-3.94-3.31-4.11 22.97-10.92 19 3.77 1.85-3.71-19.78-3.93-.31-.57 9.62-12.95-3.64-1.81-8.06 10.86-10.18-19.12 17.09-8.26 2.91-5.85-23.49 11.36-4.48 1.51 2.71-20.84 8.78-1.51 1.82.96.42-.8 16.35 5.08 1.8-3.62-.07-.03-.87-.27.13-.1-3.98-1.98-.81.63-10.65-3.31 1.26-2.39-3.58-1.78-1.88 3.56-7.67 1.32-.05-.01Zm-38.93 21.89 4.44-6.13 11.37 13.27-17-2.98 1.19-4.17v.01Zm-5.93 20.73 3.63-12.69 21.09 3.69-.39 4.02-24.33 4.98Zm16.44 40.28-5.07-5.75-6.88-15.17 19.81-7.9 7.61 9.88-15.48 18.94h.01Zm17.27-23.17-6.67-8.65 1.39-14.25.1.12.11-1.56 12.29 7.54-7.22 16.8Zm4.16.44 6.5-15.13 11.05 6.78-17.55 8.35Zm7.5-32.31 10.36 19.46-24.15-14.83 13.79-4.63Zm-8.49-1.36-7.78 2.61 1.66-22.62 8.93-1.54-2.81 21.54v.01ZM936.66 648.6l-.91-25.11 28.39 16.56h27.44l.82 2.47c1.46.1 2.91.22 4.34.35l-2.29-6.81h-29.23l-29.64-17.31-.4-11.16c-1.32.32-2.64.65-3.97 1l1.49 41.25c1.32-.43 2.64-.86 3.96-1.25v.01ZM769.82 449.45l1.91-3.84 3.22 1.6 22.36-9.76 14.29-5.56 2.65-5.32-18.46 7.19-60.92 26.58 4.67 2.32 30.28-13.21ZM794.09 400.61l-74.49 19.08 5.48 2.73 66.66-17.08 2.35-4.73Z"
        />
        <defs>
            <linearGradient
                id="f"
                x1={857.44}
                x2={857.44}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="g"
                x1={741.96}
                x2={741.96}
                y1={881.54}
                y2={1010.31}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="h"
                x1={1166.9}
                x2={1166.9}
                y1={911.771}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="i"
                x1={1529.76}
                x2={1529.76}
                y1={932.661}
                y2={1061.42}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="j"
                x1={1229.49}
                x2={1229.49}
                y1={896.24}
                y2={960.62}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="k"
                x1={1412.26}
                x2={1412.26}
                y1={896.24}
                y2={960.62}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="l"
                x1={1653.82}
                x2={1653.82}
                y1={903.199}
                y2={967.58}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="m"
                x1={1786.73}
                x2={1786.73}
                y1={920.28}
                y2={984.66}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="n"
                x1={1054.52}
                x2={1054.52}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="o"
                x1={905.96}
                x2={905.96}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="p"
                x1={630.8}
                x2={630.8}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="q"
                x1={210.43}
                x2={210.43}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="r"
                x1={79.74}
                x2={79.74}
                y1={983.77}
                y2={1112.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="s"
                x1={19.39}
                x2={19.39}
                y1={919.36}
                y2={1015.47}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="t"
                x1={350.87}
                x2={350.87}
                y1={937.93}
                y2={1024.4}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="u"
                x1={665.44}
                x2={665.44}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="v"
                x1={996.78}
                x2={996.78}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="w"
                x1={1157.72}
                x2={1157.72}
                y1={911.769}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="x"
                x1={1317.96}
                x2={1317.96}
                y1={911.77}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="y"
                x1={573.39}
                x2={573.39}
                y1={911.771}
                y2={1040.54}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3D0F9" />
                <stop offset={1} stopColor="#CAABF0" />
            </linearGradient>
            <linearGradient
                id="z"
                x1={1440.7}
                x2={1440.7}
                y1={-858.58}
                y2={472.99}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D6BDF4" />
                <stop offset={1} stopColor="#B087E9" />
            </linearGradient>
            <linearGradient
                id="A"
                x1={1805.7}
                x2={1378.78}
                y1={889.87}
                y2={392.93}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#A776E5" />
                <stop offset={1} stopColor="#B489EA" />
            </linearGradient>
            <linearGradient
                id="E"
                x1={193.05}
                x2={586.09}
                y1={259.45}
                y2={769.94}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D8BFF6" />
                <stop offset={1} stopColor="#B087E9" />
            </linearGradient>
            <linearGradient
                id="F"
                x1={971.436}
                x2={833.865}
                y1={63.871}
                y2={792.783}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D6BDF4" />
                <stop offset={1} stopColor="#B087E9" />
            </linearGradient>
            <linearGradient
                id="H"
                x1={854.248}
                x2={667.761}
                y1={117.425}
                y2={180.077}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#B489EA" />
                <stop offset={1} stopColor="#9B64E1" />
            </linearGradient>
            <radialGradient
                id="a"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(302.497 0 0 41.855 1539.79 985.001)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E9E4E0" />
                <stop offset={0.7} stopColor="#E9E4E0" stopOpacity={0.03} />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="b"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(213.954 0 0 10.4137 1508.18 979.989)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#DAD3CF" />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="c"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(213.954 0 0 10.4137 1508.18 979.989)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E9E4E0" />
                <stop offset={0.7} stopColor="#E9E4E0" stopOpacity={0.03} />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="d"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(429.965 0 0 41.855 930.862 817.04)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E9E4E0" />
                <stop offset={0.7} stopColor="#E9E4E0" stopOpacity={0.03} />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="e"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(302.498 0 0 41.855 482.756 817.04)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E9E4E0" />
                <stop offset={0.7} stopColor="#E9E4E0" stopOpacity={0.03} />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="B"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(213.954 0 0 10.4137 874.339 979.989)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#DAD3CF" />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="C"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(213.954 0 0 10.4137 497.8 979.989)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E9E4E0" />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="D"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="matrix(213.954 0 0 10.4137 497.8 889.415)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#DAD3CF" />
                <stop offset={1} stopColor="#E9E4E0" stopOpacity={0} />
            </radialGradient>
            <radialGradient
                id="G"
                cx={0}
                cy={0}
                r={1}
                gradientTransform="rotate(-18.57 1571.958 -2650.385) scale(304.52)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#CAABF0" />
                <stop offset={1} stopColor="#fff" stopOpacity={0} />
            </radialGradient>
        </defs>
    </svg>
)
